import Fetch from "../../components/fetch";

export default class Verses {
	constructor() {
		this.api = new Fetch;
	}

	async getVerses(book, start, end, testament = false, search = false, page = false) {

		if (book) {
			const params = this.api.buildQueryParamns({
				search: search,
				page: page,
			});

			if (start && end) {
				book = `${book}_${start}_${end}`;

				return await this.api.send(`chapter/${book}?${params}`);
			}

			return await this.api.send(`verses/${book}/?${params}`);

		} else {
			return await this.search(search, testament, page);
		}
	}

	async search(search, testament= false, page = false, perPage = false) {
		const params = this.api.buildQueryParamns({
			search: search,
			per_page: perPage,
			page: page,
			testament: testament
		});

		return await this.api.send(`verses/?${params}`);
	}
}
